import { useEffect, useState } from 'react';
import { GO2RTC_URL } from '@/lib/authFetch';

type Go2rtcStreams = Record<string, { producers?: { medias?: string[] }[] | null } | null>;

async function resolveLiveStreamName(streamName: string): Promise<string> {
  try {
    const response = await fetch(`${GO2RTC_URL}/api/streams`);
    if (!response.ok) return streamName;
    const streams: Go2rtcStreams = await response.json();
    const h264Name = `${streamName}_h264`;
    if (!streams[h264Name]) return streamName;
    const producers = streams[streamName]?.producers ?? [];
    const sendsH265 = producers.some((producer) =>
      (producer.medias ?? []).some((media) => media.includes('H265'))
    );
    return sendsH265 ? h264Name : streamName;
  } catch {
    return streamName;
  }
}

/**
 * Nome do stream go2rtc a abrir no player. Câmeras RTMP em H265 têm uma cópia
 * `<nome>_h264` convertida no servidor; as demais abrem o stream original.
 */
export function useLiveStreamName(streamName: string | null): string | null {
  const [resolved, setResolved] = useState<string | null>(null);

  useEffect(() => {
    setResolved(null);
    if (!streamName) return;
    let cancelled = false;
    resolveLiveStreamName(streamName).then((name) => {
      if (!cancelled) setResolved(name);
    });
    return () => {
      cancelled = true;
    };
  }, [streamName]);

  return resolved;
}
